export const categories = [
  {
    id: 'smart-home',
    name: '智能家居',
    icon: 'ri-home-4-line',
    description: 'MJHL 智能家居解决方案，让科技融入生活的每个角落，打造智慧、便捷、舒适的居家体验。',
    products: [
      {
        id: 'sh-1',
        name: 'MJHL 智能中枢 Hub Pro',
        description: '全屋智能控制中心，支持 200+ 设备联动，AI 自学习场景模式，语音/APP/触控三种操控方式。',
        image: 'https://readdy.ai/api/search-image?query=Modern%20smart%20home%20hub%20device%20on%20a%20minimalist%20wooden%20desk%20with%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20sleek%20circular%20design%20with%20LED%20indicators%2C%20premium%20product%20photography%2C%20warm%20ambient%20atmosphere&width=600&height=480&seq=mjhl-cat-sh-1&orientation=landscape',
        features: ['AI 场景学习', '200+ 设备兼容', '语音/APP/触控', '7x24 安全监控'],
      },
      {
        id: 'sh-2',
        name: 'MJHL 智能门锁 SafeLock X',
        description: '3D 人脸识别 + 指纹 + 密码 + 远程开锁，金融级安全芯片，C 级锁芯，全天候安全守护。',
        image: 'https://readdy.ai/api/search-image?query=Premium%20smart%20door%20lock%20with%20brushed%20metal%20finish%20on%20a%20modern%20wooden%20door%2C%20minimalist%20design%2C%20soft%20studio%20lighting%2C%20clean%20white%20wall%20background%2C%20professional%20product%20photography%2C%20warm%20neutral%20tones&width=600&height=480&seq=mjhl-cat-sh-2&orientation=landscape',
        features: ['3D 人脸识别', '金融级安全芯片', 'C 级锁芯', '远程临时密码'],
      },
      {
        id: 'sh-3',
        name: 'MJHL 环境传感器套装',
        description: '温湿度/PM2.5/CO2/VOC 多合一检测，实时空气质量报告，自动联动净化设备。',
        image: 'https://readdy.ai/api/search-image?query=Sleek%20environmental%20sensor%20device%20set%20on%20a%20minimalist%20shelf%20with%20digital%20display%2C%20clean%20modern%20interior%2C%20soft%20natural%20light%2C%20warm%20wood%20textures%2C%20professional%20product%20photography%2C%20cozy%20atmosphere&width=600&height=480&seq=mjhl-cat-sh-3&orientation=landscape',
        features: ['多合一检测', '实时报告', '自动联动', '历史趋势分析'],
      },
    ],
  },
  {
    id: 'business',
    name: '企业服务',
    icon: 'ri-building-2-line',
    description: 'MJHL 企业级数字化解决方案，助力企业高效运营，降低管理成本，加速数字化转型进程。',
    products: [
      {
        id: 'bs-1',
        name: 'MJHL 企业协同平台 WorkFlow',
        description: '一站式企业办公协同平台，整合即时通讯、项目管理、文档协作、视频会议，提升团队效率 300%。',
        image: 'https://readdy.ai/api/search-image?query=Modern%20business%20collaboration%20software%20dashboard%20on%20a%20laptop%20screen%20in%20a%20bright%20office%20setting%2C%20clean%20minimalist%20UI%20design%2C%20warm%20natural%20lighting%2C%20professional%20workspace%20aesthetic%2C%20soft%20shadows%2C%20contemporary%20office%20interior&width=600&height=480&seq=mjhl-cat-bs-1&orientation=landscape',
        features: ['即时通讯', '项目管理', '文档协作', '视频会议'],
      },
      {
        id: 'bs-2',
        name: 'MJHL 数据中台 DataCore',
        description: '企业级数据中台解决方案，打通数据孤岛，实时数据分析与可视化，驱动智能决策。',
        image: 'https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20interface%20displayed%20on%20multiple%20screens%20in%20a%20modern%20office%2C%20clean%20minimalist%20design%2C%20warm%20ambient%20lighting%2C%20professional%20setting%2C%20sleek%20monitors%2C%20contemporary%20workspace&width=600&height=480&seq=mjhl-cat-bs-2&orientation=landscape',
        features: ['数据整合', '实时分析', '可视化报表', '智能决策'],
      },
      {
        id: 'bs-3',
        name: 'MJHL 智能客服机器人 AI-Service',
        description: '基于大语言模型的智能客服系统，7x24 小时在线，准确率 97%，支持多语言，降低 80% 人工成本。',
        image: 'https://readdy.ai/api/search-image?query=AI%20chatbot%20interface%20on%20a%20clean%20desktop%20screen%20with%20modern%20minimalist%20design%2C%20soft%20warm%20lighting%2C%20professional%20office%20environment%2C%20sleek%20typography%2C%20contemporary%20workspace%20aesthetic&width=600&height=480&seq=mjhl-cat-bs-3&orientation=landscape',
        features: ['大语言模型', '7x24 在线', '多语言支持', '97% 准确率'],
      },
    ],
  },
  {
    id: 'health',
    name: '健康科技',
    icon: 'ri-heart-pulse-line',
    description: 'MJHL 健康科技产品，用科技守护您的健康，提供全方位的健康监测与管理方案。',
    products: [
      {
        id: 'ht-1',
        name: 'MJHL 健康手环 VitalBand Pro',
        description: '全天候心率/血氧/血压/睡眠监测，AI 健康分析报告，IP68 防水，15 天超长续航。',
        image: 'https://readdy.ai/api/search-image?query=Sleek%20fitness%20health%20tracker%20band%20on%20a%20minimalist%20white%20surface%20with%20soft%20natural%20lighting%2C%20premium%20build%20quality%2C%20clean%20product%20photography%2C%20warm%20neutral%20background%2C%20modern%20wearable%20tech%20aesthetic&width=600&height=480&seq=mjhl-cat-ht-1&orientation=landscape',
        features: ['心率/血氧/血压', 'AI 健康报告', 'IP68 防水', '15 天续航'],
      },
      {
        id: 'ht-2',
        name: 'MJHL 智能体脂秤 BodySense',
        description: 'BIA 生物电阻抗技术，18 项身体数据精准测量，AI 体态评估，全家健康管理。',
        image: 'https://readdy.ai/api/search-image?query=Premium%20smart%20body%20composition%20scale%20on%20a%20minimalist%20bathroom%20floor%20with%20soft%20natural%20lighting%2C%20clean%20white%20tiles%2C%20modern%20elegant%20design%2C%20professional%20product%20photography%2C%20warm%20neutral%20atmosphere&width=600&height=480&seq=mjhl-cat-ht-2&orientation=landscape',
        features: ['18 项身体数据', 'AI 体态评估', '全家管理', '高精度 BIA'],
      },
    ],
  },
  {
    id: 'education',
    name: '教育科技',
    icon: 'ri-graduation-cap-line',
    description: 'MJHL 教育科技产品，赋能数字化教育转型，打造智慧课堂与个性化学习体验。',
    products: [
      {
        id: 'ed-1',
        name: 'MJHL 智慧课堂 EduSmart',
        description: '互动教学一体机 + 云端备课平台，支持远程授课、实时互动、AI 学情分析。',
        image: 'https://readdy.ai/api/search-image?query=Modern%20interactive%20smart%20classroom%20display%20in%20a%20bright%20educational%20setting%2C%20minimalist%20design%2C%20warm%20natural%20light%2C%20clean%20white%20walls%2C%20contemporary%20learning%20environment%2C%20professional%20photography&width=600&height=480&seq=mjhl-cat-ed-1&orientation=landscape',
        features: ['互动教学', '云端备课', '远程授课', 'AI 学情分析'],
      },
      {
        id: 'ed-2',
        name: 'MJHL 自适应学习系统 LearnPath',
        description: '基于知识图谱的自适应学习引擎，为每位学生定制个性化学习路径，提升学习效率 50%。',
        image: 'https://readdy.ai/api/search-image?query=Digital%20learning%20platform%20on%20a%20clean%20tablet%20screen%20with%20colorful%20knowledge%20graph%20visualization%2C%20warm%20ambient%20lighting%2C%20modern%20educational%20technology%2C%20cozy%20study%20environment%2C%20minimalist%20design&width=600&height=480&seq=mjhl-cat-ed-2&orientation=landscape',
        features: ['知识图谱', '个性化路径', '自适应引擎', '效率提升 50%'],
      },
    ],
  },
];

export const categoryTabs = categories.map((c) => ({ id: c.id, name: c.name, icon: c.icon }));